// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import AccordionController from "./accordion_controller"
import WebinarCalendarController from "./webinar_calendar_controller"
import ShareController from "./share_controller"
import PaymentController from "./payment_controller"
import VideoPlayerController from "./video_player_controller"
import QuestionController from "./question_controller"
import ExamTimerController from "./exam_timer_controller"
import ScrollController from "./scroll_controller"
import ModalController from "./modal_controller"
import ExamInterfaceController from "./exam_interface_controller"

application.register("hello", HelloController)
application.register("accordion", AccordionController)
application.register("webinar-calendar", WebinarCalendarController)
application.register("share", ShareController)
application.register("payment", PaymentController)
application.register("video-player", VideoPlayerController)
application.register("question", QuestionController)
application.register("exam-timer", ExamTimerController)
application.register("scroll", ScrollController)
application.register("modal", ModalController)
application.register("exam-interface", ExamInterfaceController)

// Import our custom navbar controller
import "./navbar_controller"
